import dayjs from "dayjs";

export const generateFileName = (contentType: string): string => {
  // We have no guarantee of getting the file name from expo image picker
  // so let's generate a name for our users upload when missing
  // There might be a way to extract it from the URI but not sure
  // how reliable that would be - so skipping for now
  const extension = getContentExtension(contentType);
  return `${dayjs().format("YYYY-MM-DD-HH-mm-ss")}_image${extension}`;
};

// See
// https://ai.google.dev/gemini-api/docs/prompting_with_media?lang=python#image_formats
// for more information on supported image types
const supportedMimeToExtensionMap: { [key: string]: string } = {
  "image/jpeg": ".jpg",
  "image/png": ".png",
  "image/heic": ".heic",
  "image/heif": ".heif",
  "image/webp": ".webp",
};

const getContentExtension = (contentType: string): string => {
  return supportedMimeToExtensionMap[contentType] || "";
};

const SupportedImageTypes = Object.keys(supportedMimeToExtensionMap);

export const isSupportedImageType = (contentType: string): boolean => {
  return SupportedImageTypes.includes(contentType);
};
